import React from "react";
import ReactDOM from "react-dom";
// import "./index.scss";
import "primeicons/primeicons.css";
import App from "./App";
import "./sb-admin-2.min.css";
import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "./components/AuthProvider/AuthProvider";
ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
